import React from 'react';
import RestaurantClientShell from './restaurants/client/RestaurantClientShell';

/**
 * Compatibility wrapper retained for ClientDashboard and existing imports.
 * The responsive customer experience lives in components/restaurants/client.
 */
const RestaurantMarketplace = ({ onOrderCreated, onBack = () => {} }) => (
  <RestaurantClientShell onBack={onBack} onOrderCreated={onOrderCreated} />
);

export default RestaurantMarketplace;
